import '../styles/App.css';
import '../styles/TrustedBy.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import { useEffect, useState } from 'react';
import gsap from 'gsap';
import PartnerSwiper from "../components/PartnerSwiper";
import USP from "../components/USP";
import ComingSoon from "../components/ComingSoon";
import Blogs from "../components/Blogs";
import BannerSwiper from "../components/BannerSwiper";
import { useTranslation } from "react-i18next";

function HomePage() {
  const [t] = useTranslation();
  // GSAP animation for the phone image
  useEffect(() => {
    try {
      const tl = gsap.timeline();
      tl.fromTo(".phone-image", { opacity: 0 }, { opacity: 1, duration: 2 });
    } catch (error) {}
  }, []);
    const [backgroundElementUrl, setBackgroundElementUrl] = useState(
        "/Images/background/bg-element.jpeg"
    );

    useEffect(() => {
        const updateSize = () => {
            if (window.innerWidth < 768) {
                setBackgroundElementUrl("/Images/background/bg-element-mob.png");
            } else {
                setBackgroundElementUrl("/Images/background/bg-element.jpeg");
            }
        };
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);

  return (
      <>
        <Navbar />
        <section className="banner-section">
        <BannerSwiper />
        </section>

        <section className="usp-section">
        <USP />
        </section>

        <img src={backgroundElementUrl} alt="background element" style={{maxWidth:`40%`}} />

        <Blogs />

        <PartnerSwiper />

        <ComingSoon />

        {/* Trusted By Section */}
        <section className="trusted-by-section">
          <h2 className="trusted-by-title">{t('trusted_by.title')}</h2>
          <div className="trusted-by-grid">
            {/* Row 1 */}
            <div className="trusted-by-row">
              <img src="/Images/ourstory/hkstp-logo.png" alt="HKSTP Partner" className="trusted-by-logo logo-hkstp" />
              <div className="trusted-by-separator-v sep-left" />
              <img src="/Images/ourstory/cityu-hktech300-logo.png" alt="CityU HK Tech 300" className="trusted-by-logo logo-cityu" />
              <div className="trusted-by-separator-v sep-right" />
              <img src="/Images/ourstory/polyventures-logo.png" alt="PolyVentures" className="trusted-by-logo logo-polyu" />
            </div>
            {/* Row 2 */}
            <div className="trusted-by-row trusted-by-row-2">
              <img src="/Images/ourstory/google-logo.png" alt="Google" className="trusted-by-logo logo-bottom" />
              <div className="trusted-by-separator-v" />
              <img src="/Images/ourstory/aws-logo.png" alt="Amazon AWS" className="trusted-by-logo logo-bottom" />
              <div className="trusted-by-separator-v" />
              <img src="/Images/ourstory/microsoft-logo.png" alt="Microsoft" className="trusted-by-logo logo-microsoft logo-microsoft-bottom" />
            </div>
          </div>
        </section>

        <Footer />
      </>
  );
}

export default HomePage;
